import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
/* reducer */
import * as fromDailyProgramItemDataStore from './state/daily-program-item-data-store.reducer';

/* effects */
import { DailyProgramItemDataStoreEffects } from './state/daily-program-item-data-store.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,

    /* DailyProgramItemDataStore State */
    StoreModule.forFeature(
      fromDailyProgramItemDataStore.featureKey,
      fromDailyProgramItemDataStore.reducer,
      { initialState: fromDailyProgramItemDataStore.initialState },
    ),
    EffectsModule.forFeature([DailyProgramItemDataStoreEffects]),
  ],
  exports: [StoreModule, EffectsModule],
})
export class DailyProgramItemDataStoreModule {}
